<template>
    <section class="section">
        <div class="container">
            <h1 class="title is-4">Skift password</h1>
            <div class="columns">
                <div class="column is-half">
                    <form-field
                        label="Nuværende password"
                        :error="error.currentPassword"
                    >
                        <input-text
                            type="password"
                            v-model="form.currentPassword"
                            :error="error.currentPassword"
                        />
                    </form-field>
                    <form-field
                        label="Nyt password"
                        :error="error.newPassword"
                    >
                        <input-text
                            type="password"
                            v-model="form.newPassword"
                            :error="error.newPassword"
                        />
                    </form-field>
                    <form-field
                        label="Gentag nyt password"
                        :error="error.newPassword_confirmation"
                    >
                        <input-text
                            type="password"
                            v-model="form.newPassword_confirmation"
                            :error="error.newPassword_confirmation"
                        />
                    </form-field>
                    <div class="field">
                        <button class="button is-primary" @click="submit">Skift password</button>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import { FormField, InputText } from '@elems/form'
import store from '../../store'
import { setTimeout } from 'timers';

export default {
    components: {
        FormField,
        InputText,
    },
    data() {
        return {
            form: {
                currentPassword: '',
                newPassword: '',
                newPassword_confirmation: '',
            },
            error: [],
        }
    },
    methods: {
        submit() {
            window.axios.put('/api/settings/profile/change-password', this.form)
                .then((response) => {
                    store.dispatch('setSuccess', 'Password skiftet!')

                    setTimeout(() => {
                        store.dispatch('setSuccess', '')
                    }, 2000)

                    this.reset()
                })
                .catch(error => {
                    if (error.request.status === 422) {
                        this.error = error.response.data.errors || []
                    } else {
                        store.dispatch('setError', 'Password kunne ikke skiftes.')
                    }
                })
        },
        reset() {
            this.form = {
                currentPassword: '',
                newPassword: '',
                newPassword_confirmation: '',
            }
            this.error = []
        }
    }

}
</script>

<style>

</style>
